import reducer from './reducer'
export { default as operations } from './operations'

export default reducer
